import React, { useState } from 'react';

import styles from './PatientDischargeButton.module.css';
import { ReactComponent as CloseEpisode } from '../../../assets/icons/close-episode.svg';

import { useTranslation } from 'react-i18next';

import Modal from '../../UI/Modal/Modal';
import CloseCaseDialog from '../CloseCaseDialog/CloseCaseDialog';

import { Case } from '../../../interfaces/Patient';

interface Props {
    caso: Case | null
    disabled: boolean;
    updateCase: (body: Partial<Case>) => void
}

const PatientDischargeButton: React.FC<Props> = ({ caso, disabled, updateCase }) => {

    const { t } = useTranslation();

    const [showModal, setShowModal] = useState(false);

    return (
        <>
            <button
                className={`button ${styles.buttonCloseCase}`}
                onClick={() => setShowModal(true)}
                disabled={disabled}
            >
                {t('close_case')}
                <CloseEpisode />
            </button>
            <Modal show={showModal} setShowModal={setShowModal}>
                {caso &&
                    <CloseCaseDialog
                        caso={caso}
                        closeModal={() => setShowModal(false)}
                        updateCase={updateCase}
                    />
                }
            </Modal>
        </>
    );
};

export default PatientDischargeButton;